module.exports = __webpack_public_path__ + "img/48.7688389f.webp";